import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { GflexImportFailure } from '../../../../core/models/operation-advance/gflex-import-failure';

/**
 * Dedicated failure dialog for the GFLEX medical advance import (spec D8). Kept as its
 * own component precisely so `ErrorService` and `PopupModalComponent` — shared by every
 * screen in the portal — never need to change to support this one flow.
 *
 * The failure list is uncapped (spec §7.6) and must scroll without breaking layout; see
 * the `.failure-table-holder` rule in the stylesheet. All values render through Angular
 * interpolation only — `reason`, `invoiceNo` etc. come straight out of an uploaded file
 * and must never be passed through `[innerHTML]`.
 */
@Component({
    selector: 'popup-import-error',
    templateUrl: './popup-import-error.component.html',
    styleUrls: ['./popup-import-error.component.scss'],
})
export class PopupImportErrorComponent {
    title = 'Import Failed';
    failures: GflexImportFailure[] = [];

    constructor(public activeModal: NgbActiveModal) {}

    get failureCount(): number {
        return this.failures ? this.failures.length : 0;
    }

    close(): void {
        this.activeModal.dismiss();
    }
}
